import Home from "../pages/Landing/Home";
const landingRoutes = (isLogged = false) =>
  [
    { path: "", element: <Home /> },
  ].filter(Boolean);
export default landingRoutes;
